<ng-container [ngSwitch]="context ? context.type : ''">
    <fui-edit-autocomplete-input [control]="control" [disabled]="disabled" [field]="valueField" #input
                                 [key]="labelField" [label]="label" [loading]="loading" [(ngModel)]="value"
                                 (focussed$)="onFocussed($event)" *ngSwitchDefault [options]="options"
                                 [placeholder]="placeholder" (filtered$)="filtered$.emit($event)">
    </fui-edit-autocomplete-input>
    <fui-filter-autocomplete-input [control]="control" [disabled]="disabled" [field]="valueField" #input
                                   [key]="labelField" [label]="label" [loading]="loading" [(ngModel)]="value"
                                   (focussed$)="onFocussed($event)" *ngSwitchCase="contextType.FILTER" [options]="options"
                                   [placeholder]="placeholder" (filtered$)="filtered$.emit($event)">
    </fui-filter-autocomplete-input>
    <fui-inline-autocomplete-input [control]="control" [disabled]="disabled" [field]="valueField" #input
                                   [key]="labelField" [label]="label" [loading]="loading" [(ngModel)]="value"
                                   (focussed$)="onFocussed($event)" *ngSwitchCase="contextType.INLINE" [options]="options"
                                   [placeholder]="placeholder" (filtered$)="filtered$.emit($event)">
        <fui-icon [height]="16" [icon]="'search-group'" [width]="16"></fui-icon>
    </fui-inline-autocomplete-input>
    <fui-autocomplete-pill [control]="control" [disabled]="disabled" [field]="valueField" #input
                           [key]="labelField" [label]="label" [loading]="loading" [(ngModel)]="value"
                           (focussed$)="onFocussed($event)" *ngSwitchCase="contextType.PILL" [options]="options"
                           [placeholder]="placeholder" (filtered$)="filtered$.emit($event)">
    </fui-autocomplete-pill>
</ng-container>
